import React from 'react';
import '../../../CSS/UI Components/NewServiceCard.css';
import clockIcon from '../../../Assets/clockIcon.png'

const NewServiceCard = ({
  state,
  onPressCard,
  serviceData
}) => {
  if(serviceData.AT_HOME_SERVICE_NAME && serviceData.AT_HOME_SERVICE_NAME.length > 30){
    serviceData.AT_HOME_SERVICE_NAME = serviceData.AT_HOME_SERVICE_NAME.substring(0,30) + '...'
  }
   const formatDuration = (minutes) => {
        const hrs = Math.floor(minutes / 60);
        const mins = minutes % 60;
        let result = '';
        if (hrs > 0) {
            result += hrs + (hrs === 1 ? ' hr' : ' hrs');
        }
        if (mins > 0) {
            if (result) result += ' ';
            result += mins + ' mins';
        }
        if (!result) result = '0 min';
        return result;
    };
  return (
    <div className="npc-card" onClick={onPressCard} style={{ cursor: 'pointer' }}>
      <div style={{ position: 'relative' }}>
        <img
          src={serviceData.PROFESSIONAL_IMAGE || serviceData.image_link}
        //   alt={serviceData.MERCHANT_NAME}
          className="npc-card-image"
        />
        {/* <div className="npc-rating-tag">
          <span className="npc-rating-text">
            {"4.5"} <span style={{ color: '#92c63d', fontSize: 14 }}>★</span>
          </span>
        </div> */}
      </div>
      <div className="npc-service-details">
        <div className="npc-card-title">
          {/* {serviceData.MERCHANT_NAME} */}
          {serviceData ? serviceData.AT_HOME_SERVICE_NAME : "Service Name"} 
        </div>
        {/* {!(clickOnAtHome || serviceData.MERCHANT_PERSONNEL_STORE_TYPE === 'virtual') && ( */}
          <div className="npc-location-row">
            {/* <text style={[styles.slashedPriceStyle, { marginRight: 8 }]}>{(data.SERVICE_CURRENCY === "Rupees" ? '\u20B9' : "$") + data.service_list_price}</text>
            <text style={[styles.priceStyle, { marginRight: 3,color:data.serviceCard ? (data.serviceCard == 1 ? "#f69708" : (data.serviceCard == 2 ? "#007bd5" : (data.serviceCard == 3 ? "#db2bc9" : "#2d2d2d"))) : "#2d2d2d"}]}>{(data.SERVICE_CURRENCY === "Rupees" ? '\u20B9' : "$") + data.service_offer_price}</text> */}
            <text className='listPriceStyle'>{( '\u20B9') + serviceData.service_list_price}</text>
            <text className='offerPriceStyle'>{('\u20B9') + serviceData.service_offer_price}</text>
            <div className='discountContainer'>
                <text className='discountStyle'>{ serviceData.service_discount + " %Off " }</text>
            </div>
          </div>
        {/* )}  */}
        <div className="npc-line-style" />
        <div className='durationDivStyle'>
            <img src={clockIcon} style={{ width: 15, height: 15 }} />
            {/* <Text style={styles.durationStyle}>{moment.utc(moment.duration(data.SERVICE_DURATION_IN_MINS, "minutes").asMilliseconds()).format("H") == 0 ? null : moment.utc(moment.duration(data.SERVICE_DURATION_IN_MINS, "minutes").asMilliseconds()).format("H") + "h"}{' '}{moment.utc(moment.duration(data.SERVICE_DURATION_IN_MINS, "minutes").asMilliseconds()).format("mm") == 0 ? null : moment.utc(moment.duration(data.SERVICE_DURATION_IN_MINS, "minutes").asMilliseconds()).format("mm") + "m"}</Text> */}
            <text className='durationStyle'> {formatDuration(serviceData.AT_HOME_SERVICE_DURATION)}</text>
        </div>
      </div>
      {/* Add discount or other tags as needed */}
    </div>
  );
};

export default NewServiceCard;